export const VAR_SERVICE_AS_PROCEDURE = '#{servicoComoProcedimento}';
export const VAR_CUSTOMER_NAME = '#{cliente}';
export const VAR_SERVICE_NAME = '#{servico}';
export const VAR_DATE_AND_START_TIME = '#{data_horario}';
export const VAR_PROFESSIONAL_NAME = '#{profissional}';
export const VAR_COURT_NAME = '#{quadra}';
export const VAR_TOTAL_SERVICE_VALUE_NAME = '#{valorTotal}';
export const VAR_DATE_FORMAT_1 = '#{data_formato1}';
export const VAR_DATE_FORMAT_2 = '#{data_formato2}';
export const VAR_START_TIME = '#{hora_inicio}';
export const VAR_END_TIME = '#{hora_fim}';
export const VAR_FULL_CUSTOMER_NAME = '#{cliente_completo}';

export const ALL_APPOINTMENT_VARS = [
  VAR_CUSTOMER_NAME,
  VAR_SERVICE_NAME,
  VAR_DATE_AND_START_TIME,
  VAR_PROFESSIONAL_NAME,
  VAR_COURT_NAME,
  VAR_TOTAL_SERVICE_VALUE_NAME,
  VAR_DATE_FORMAT_1,
  VAR_DATE_FORMAT_2,
  VAR_START_TIME,
  VAR_END_TIME,
  VAR_FULL_CUSTOMER_NAME,
];
